import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';

/*
  Generated class for the LicenciasProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LicenciasProvider {

  private api: string = "";
  public listaponentes = [];
  constructor(public http: Http, public global: GlobalProvider) {
    this.api = this.global.api;
    console.log('Hello PonentesProvider Provider');

    // this.listaponentes = json 
    // o
    // this.listaponentes =  window.localStorage["ponentes"];



  }

  // Elimina un congreso
  public delete(licencia): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "tabla": "licencias",
      "clave": licencia,
    };

    return this.http.post(this.api + "apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public insert(licencia): Observable<any> {
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token,
      "tabla": "licencias",
      "parametros": licencia
    };

    return this.http.post(this.api + "apigen/insert.php", parametros, options).map(
      (response) => {
        return response.json();
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public update(licencia): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros = {
      "token": this.global.token,
      "clave": licencia.clave,
      "tabla": "licencias",
      "parametros": licencia
      //  "imagen": imagen
    };

    return this.http.post(this.api + "apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();

        return respuesta[0];
      }
    ).catch(this.handleError);
  }


  public all(): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros = {
      "token": this.global.token
    };
console.log(parametros);
console.log(this.api + "licencias/lista.php");
    return this.http.post(this.api + "licencias/lista.php", parametros, options).map(
      (response) => {


        
        return response.json();

      }
    ).catch(this.handleError);
  }
  public allcongresos(): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "tabla":"congresos",
      "campoorden": "descripcion"
    };
   console.log(parametros);
   console.log(this.api+"apigen/list.php");
    return this.http.post(this.api+"apigen/list.php", parametros, options).map(
      (response) => {
        
       console.log(response);
        // this.listaponentes =  response.json();
        // storage = this.listaponentes;
     
        return response.json();
        
      }
    ).catch(this.handleError);
  }


  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/providers/licencias/licencias.ts